import { getCookie, setCookie } from './cookieHelper';
import {
  TRACKING_DETAILS_COOKIE,
  TRACKING_DETAILS_ATTRIBUTION_WINDOW_DAYS,
} from '../../constants/cookies';
import {
  getAffParam,
  getCJeventParam,
  getPromotionParam,
} from './referrerHelper';

const buildTrackingDetails = (query = {}) => {
  const { aff, a, p, cjevent, im_ref: imRef } = query;
  return {
    AffiliateCode: aff || getAffParam() || a,
    CJEvent: cjevent || getCJeventParam(),
    PromotionCode: p || getPromotionParam(),
    ReferrerUrl: imRef ? window.location.href : document.referrer,
  };
};

/**
 * Persists partner/affiliate tracking info (im_ref, aff, cjevent, promo) into
 * the attribution cookie. Called on every entry page (login and registration)
 * so the info survives navigating between them until the user logs in or
 * registers. A visit with no tracking info leaves any earlier cookie untouched.
 */
export const captureTrackingDetails = (query = {}) => {
  const details = buildTrackingDetails(query);
  const { AffiliateCode, CJEvent, PromotionCode } = details;

  if (!(AffiliateCode || CJEvent || PromotionCode || query.im_ref)) return;

  setCookie(
    TRACKING_DETAILS_COOKIE,
    JSON.stringify(details),
    TRACKING_DETAILS_ATTRIBUTION_WINDOW_DAYS,
  );
};

export const getTrackingDetailsFromCookie = () => {
  const raw = getCookie(TRACKING_DETAILS_COOKIE);
  if (!raw) return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
};

/**
 * Payload for the tracking-details API on a registration landing: the saved
 * attribution cookie when there is one, otherwise this visit's own values
 * (affiliate/promo/cjevent params and the referrer), exactly what was posted
 * before the cookie existed — so organic and cookie-blocked visits still report.
 */
export const getTrackingDetailsToPost = (query = {}) =>
  getTrackingDetailsFromCookie() || buildTrackingDetails(query);
